import { Typography, Breadcrumb } from 'antd';


const { Title } = Typography;



const PageHeader = ({ title, breadcrumbItems, children }) => {
    return (
        <div
            style={{
                background: "white",
                minHeight: 100,
                width: "100%",
                boxShadow: "inset 10px 3px 10px -10px #00000055"
            }}
        >
            <div style={{
                padding: "8px 0px 24px 24px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>

                    <Breadcrumb style={{ margin: "24px 0", fontSize: "14px" }}>
                        {breadcrumbItems.map((item, idex) =>
                            <Breadcrumb.Item key={idex}>{item}</Breadcrumb.Item>
                        )}

                    </Breadcrumb>
                    <Title level={4} >{title}</Title>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight:"12px",
                }}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default PageHeader;